<template>
    <footer class="row text-center">
        <div class="col-12 text-center">
            <router-link to="/about">{{$t("about")}}</router-link>
        </div>
        <div class="col-12 text-center" id="languages">
            <p v-if="$store.state.locale !== 'en'">
                <a @click="switchLanguage('en')">English Version</a>
            </p>
            <p v-if="$store.state.locale !== 'it'">
                <a @click="switchLanguage('it')">Italian Version</a>
            </p>
        </div>
    </footer>
</template>

<script>
export default {
    methods: {
        switchLanguage(lang) {
            this.$store.commit('setLanguage', lang);
        }
    },
    i18n: {
        messages: {
            en: {
                about: 'About'
            },
            it: {
                about: 'Chi Siamo'
            }
        }
    }
};
</script>
